import { Document, Font, View } from '@react-pdf/renderer';
import React from 'react';

import { CustomPage } from '../../components/pdf/components';

const fontFileNoraml = require('./../../assets/fonts/AvenirLTStd-Book.otf');
const fontFileSemiBold = require('./../../assets/fonts/AvenirLTStd-Roman.otf');
const fontFileBold = require('./../../assets/fonts/AvenirLTStd-Black.otf');
// import { usePdfScenarioShiftCascade } from '../dashboard/components/graphs/scenarioShiftCascade';
Font.register({
  family: 'AvenirRoman',
  fonts: [
    { src: fontFileNoraml, fontWeight: 'normal' },
    { src: fontFileSemiBold, fontWeight: 'medium' },
    { src: fontFileBold, fontWeight: 'bold' },
  ],
});
export default function PdfDocument({
  graphs,
}: {
  graphs: {
    userParam: React.ReactNode;
    scenarioDetail: React.ReactNode;
    dowVolume: React.ReactNode;
    ptsCovered: React.ReactNode;
  };
}) {
  const { dowVolume, ptsCovered, scenarioDetail, userParam } = graphs;

  return (
    <Document
      style={{
        fontFamily: 'AvenirRoman',
        fontWeight: 400,
        fontSize: 10,
      }}
    >
      <CustomPage size="A3">
        <View>{userParam}</View>
      </CustomPage>
      <CustomPage size="A3">
        <View>{scenarioDetail}</View>
      </CustomPage>
      <CustomPage size="A3" orientation="landscape">
        <View>{dowVolume}</View>
      </CustomPage>
      <CustomPage size="A3" orientation="landscape">
        <View>{ptsCovered}</View>
      </CustomPage>
      {/* <Page size="A3" orientation="landscape">
            <View>{scenarioShiftCascade}</View>
          </Page> */}
    </Document>
  );
}
